import { useMemo } from 'react';

import { ASSET_SYMBOL } from 'constants/constants';
import { CURRENCY_STYLE } from 'constants/currency';
import { STORAGE_KEYS } from 'constants/enums';
import { ENABLE_INR_TOGGLE_IN_ACCOUNT_ANALYTICS } from 'constants/featureFlag';
import useLocalStorage from 'hooks/useLocalStorage';
import { inrConversionRateSelector } from 'selectors';
import { useAppSelector } from 'storeHooks';

const useAccountAnalyticsCurrency = () => {
  const [currencyInLocalStorage, setCurrencyInLocalStorage] = useLocalStorage(
    STORAGE_KEYS.FEAT_TOGGLE_CURRENCY,
    ENABLE_INR_TOGGLE_IN_ACCOUNT_ANALYTICS ? CURRENCY_STYLE.INDIAN : ASSET_SYMBOL
  );

  const activeCurrency = ENABLE_INR_TOGGLE_IN_ACCOUNT_ANALYTICS
    ? currencyInLocalStorage
    : ASSET_SYMBOL;

  const usdToInrConversionRate = useAppSelector(inrConversionRateSelector);
  /**
   * Account Analytics data is in USD currency by default.
   * Converting it to another currency requires a conversionRate.
   * This is a mapping of conversion rates to convert USD to any currency required.
   */
  const UsdConversionRates = useMemo(
    () => ({
      [CURRENCY_STYLE.INDIAN]: usdToInrConversionRate,
    }),
    [usdToInrConversionRate]
  );

  /**
   * conversionMultiplier can simply be multiplied to your value to obtain converted value according to the activeCurrency.
   */
  const conversionMultiplier = UsdConversionRates[activeCurrency] ?? 1;

  const isCurrencyInr = activeCurrency === CURRENCY_STYLE.INDIAN;

  return {
    activeCurrency,
    setActiveCurrency: setCurrencyInLocalStorage,
    conversionMultiplier,
    isCurrencyInr,
  };
};

export default useAccountAnalyticsCurrency;
